import { render, staticRenderFns } from "./AdminDashboard2.vue?vue&type=template&id=bc83c258&scoped=true"
import script from "./AdminDashboard2.vue?vue&type=script&lang=js"
export * from "./AdminDashboard2.vue?vue&type=script&lang=js"
import style0 from "./AdminDashboard2.vue?vue&type=style&index=0&id=bc83c258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc83c258",
  null
  
)

export default component.exports